var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 16.5C1.55228 16.5 2 16.9477 2 17.5C2 17.7652 2.10536 18.0196 2.29289 18.2071C2.48043 18.3946 2.73478 18.5 3 18.5H17C17.2652 18.5 17.5196 18.3946 17.7071 18.2071C17.8946 18.0196 18 17.7652 18 17.5C18 16.9477 18.4477 16.5 19 16.5C19.5523 16.5 20 16.9477 20 17.5C20 18.2957 19.6839 19.0587 19.1213 19.6213C18.5587 20.1839 17.7957 20.5 17 20.5H3C2.20435 20.5 1.44129 20.1839 0.87868 19.6213C0.31607 19.0587 0 18.2957 0 17.5C0 16.9477 0.447715 16.5 1 16.5Z",
    fill: "#142941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 7.20711C4.68342 7.59763 5.31658 7.59763 5.70711 7.20711L10 2.91421L14.2929 7.20711C14.6834 7.59763 15.3166 7.59763 15.7071 7.20711C16.0976 6.81658 16.0976 6.18342 15.7071 5.79289L10.7071 0.792893C10.3166 0.402369 9.68342 0.402369 9.29289 0.792893L4.29289 5.79289C3.90237 6.18342 3.90237 6.81658 4.29289 7.20711Z",
    fill: "#142941"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.5C10.5523 14.5 11 14.0523 11 13.5V1.5C11 0.947715 10.5523 0.5 10 0.5C9.44771 0.5 9 0.947715 9 1.5V13.5C9 14.0523 9.44771 14.5 10 14.5Z",
    fill: "#142941"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.621c1c1fdc83f1df1dea6bb574c31e5d.svg";
export { ForwardRef as ReactComponent };